import { render, staticRenderFns } from "./chapterFocus.vue?vue&type=template&id=6e36bba0&scoped=true"
import script from "./chapterFocus.vue?vue&type=script&lang=js"
export * from "./chapterFocus.vue?vue&type=script&lang=js"
import style0 from "./chapterFocus.vue?vue&type=style&index=0&id=6e36bba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e36bba0",
  null
  
)

export default component.exports